import React, { Component } from 'react';
import { connect } from 'react-redux';

import UserSideMenu from '../../menu/UserSideMenu';
import Header from '../common/HeaderAfterLogin';

import { KYC_DETAILS } from '../../action/user_action_types';
import { postServerDataWithTypes } from '../../action/common_action';

import { getUserData } from '../../util/util';
import { endPoints, fileUrl } from '../../config';
import { history } from '../../history/history';

class KycDetailComp extends Component {
  constructor(props) {
    super(props);
    //Set initial state
    this.state = {
      userData: getUserData(),
      kycDetails: null
    };
  }

  //make a call to fetch kyc details
  componentDidMount = () => {
    let { userData } = this.state;
    let data = {
      userEmail: userData.email
    };
    this.props.getKycDetails(endPoints.getKycDetails, data, KYC_DETAILS);
  }

  //Getting kyc details
  componentWillReceiveProps = nextProps => {
    let { kycDetails } = nextProps;
    this.setState({
      kycDetails: (kycDetails && kycDetails.length > 0) ? kycDetails[0] : null
    });
  }

  //Go to update KYC route
  goToRoute= ()=> {
    let { kycDetails }= this.state;
    history.push('/updatekycdetails', {kycDetails: kycDetails? kycDetails: {}});
  }

  render() {
    let { kycDetails } = this.state;
    return (
      <div className="main_wrapper">
        <UserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper create_camp_container">
          <div className="right_wrapper_inner">
            <Header />
            <div className="dash_content_wrapper">

              <div className="content_wrapper_inner detail_content">
                <div className="create_kyc_wrapper">
                  <h2 className="detail_kyc_header">KYC DETAILS</h2>
                  <div className="kycdetails_wrapper">
                    <h2 className="kycheader">PRIMARY DETAILS</h2>
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">Contact Person</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{kycDetails ? kycDetails.name : ""}</span>
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">Email Id</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{kycDetails ? kycDetails.email : ""}</span>
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">Phone Number</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{kycDetails ? kycDetails.phone_number : ""}</span>
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">GST Number</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{(kycDetails && kycDetails.gst_Number) ? kycDetails.gst_Number : ""}</span>
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">GST Address</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{(kycDetails && kycDetails.gst_Address) ? kycDetails.gst_Address : ""}</span>
                        </div>
                      </div>

                      <div className="detail_inner margintop">
                        <span className="detailinner_header">Billing Address</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{(kycDetails && kycDetails.billing_Address) ? kycDetails.billing_Address : ""}</span>
                        </div>
                      </div>


                      <div className="detail_inner margintop">
                        <span className="detailinner_header">GST Certificate</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">{(kycDetails && kycDetails.gst_Certificate_file) ?
                            kycDetails.gst_Certificate_file.slice(kycDetails.gst_Certificate_file.lastIndexOf('/') + 1) : ""}</div>
                          <div className="detailfile_btns">
                            {(kycDetails && kycDetails.gst_Certificate_file) &&
                              <button className="download_detailfile">
                                <a href={`${kycDetails.gst_Certificate_file1}`} target= "__blank" download>DOWNLOAD</a>
                              </button>
                            }
                          </div>
                        </div>
                      </div>

                      <div className="detail_inner margintop">
                        <span className="detailinner_header"> Billing Address Proof</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">{(kycDetails && kycDetails.bill_address_cert_file) ?
                            kycDetails.bill_address_cert_file.slice(kycDetails.bill_address_cert_file.lastIndexOf('/') + 1) : ""}</div>
                          <div className="detailfile_btns">
                            {(kycDetails && kycDetails.bill_address_cert_file) &&
                              <button className="download_detailfile">
                                <a href={`${kycDetails.bill_address_cert_file1}`} target= "__blank" download>DOWNLOAD</a>
                              </button>
                            }
                          </div>
                        </div>
                      </div>



                    </div>
                    <h2 className="kycheader section_sep">PRIMARY DETAILS</h2>
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">PAN Number</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{kycDetails ? kycDetails.pan_number : ""}</span>
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">PAN Card Certificate</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">{(kycDetails && kycDetails.pan_card_cert_file) ?
                            kycDetails.pan_card_cert_file.slice(kycDetails.pan_card_cert_file.lastIndexOf('/') + 1) : ""}</div>
                          <div className="detailfile_btns">
                            {(kycDetails && kycDetails.pan_card_cert_file) &&
                              <button className="download_detailfile">
                                <a href={`${kycDetails.pan_card_cert_file1}`} target= "__blank" download>DOWNLOAD</a>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">MSA</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">{(kycDetails && kycDetails.msa_file) ?
                            kycDetails.msa_file.slice(kycDetails.msa_file.lastIndexOf('_') + 1) : ""}</div>
                          <div className="detailfile_btns">
                            {(kycDetails && kycDetails.msa_file) &&
                              <button className="download_detailfile">
                                <a href= {`${fileUrl}/${kycDetails.msa_file}`} target= "__blank" download>DOWNLOAD</a>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">TAN Number</span>
                        <div className="detailinner_input">
                          <span className="kycdetail_info">{kycDetails ? kycDetails.tan_number : ""}</span>
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">TAN Certificate</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">{(kycDetails && kycDetails.tan_cert_file) ?
                            kycDetails.tan_cert_file.slice(kycDetails.tan_cert_file.lastIndexOf('_') + 1) : ""}</div>
                          <div className="detailfile_btns">
                          {(kycDetails && kycDetails.tan_cert_file) &&
                            <button className="download_detailfile">
                              <a href= {`${fileUrl}/${kycDetails.tan_cert_file}`} target= "__blank" download>DOWNLOAD</a>
                            </button>
                          }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="save_details">
                      <button onClick= {this.goToRoute}>EDIT</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => {
  return {
    kycDetails: state.user.get('kycDetails')
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getKycDetails: (url, data, type) => dispatch(postServerDataWithTypes(url, data, type))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(KycDetailComp);


// WEBPACK FOOTER //
// ./web/components/kyc_details/KycDetailsComp.jsx